export const agrofags = {
    state: {
        status: 'idle',
        agrofags: [],
        areAllFetched: false,
        pagination: {
            limit: 20,
            page: 1
        },
        types: [],
        query: {
            agrofag_type_id: ''
        }
    },
    mutations: {
        SET_AGROFAGS_STATUS(state, status) {
            state.status = status
        },
        SET_AGROFAGS(state, agrofags) {
            state.agrofags = agrofags
        },
        SET_AGROFAGS_QUERY(state, payload) {
            if (payload.name) {
                this.$vue.set(state.query, payload.name, payload.value)
            } else {
                state.query = payload
            }
        },
        SET_AGROFAGS_PAGINATION_PAGE(state, page) {
            state.pagination.page = page
        },
        SET_AGROFAGS_ALL_FETCHED(state, areAllFetched) {
            state.areAllFetched = areAllFetched
        },
        SET_AGROFAG_TYPES(state, types) {
            state.types = types
        }
    },
    actions: {
        fetchAgrofags({ state, commit, dispatch, getters }) {
            commit('SET_AGROFAGS', [])
            commit('SET_AGROFAGS_STATUS', 'loading')
            return dispatch('resetAgrofagsPagination').then(() => {
                return this.$api.get(`api/agrofags.json?${getters.agrofagsQueryString}`).then((response) => {
                    commit('SET_AGROFAGS', response.data.data)
                    commit('SET_AGROFAGS_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.agrofags.length : response.data.data.length === 0)
                    commit('SET_AGROFAGS_STATUS', 'idle')

                    return response.data
                }).catch(error => {
                    commit('SET_AGROFAGS_STATUS', 'error')
                    return Promise.reject(error)
                })
            })
        },
        fetchAgrofagsNextPage({ state, commit, getters }) {
            if (state.areAllFetched) {
                return false
            }
            commit('SET_AGROFAGS_STATUS', 'loadingMore')
            commit('SET_AGROFAGS_PAGINATION_PAGE', state.pagination.page + 1)
            return this.$api.get(`api/agrofags.json?${getters.agrofagsQueryString}`).then((response) => {
                commit('SET_AGROFAGS', state.agrofags.concat(...response.data.data))
                commit('SET_AGROFAGS_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.agrofags.length : response.data.data.length === 0)
                commit('SET_AGROFAGS_STATUS', 'idle')
            }).catch(error => {
                commit('SET_AGROFAGS_STATUS', 'error')
                return Promise.reject(error)
            })
        },
        async fetchAgrofagTypes({ state, commit }) {
            try {
                const response = await this.$api.get('api/agrofag-types.json')
                commit('SET_AGROFAG_TYPES', response.data.data)
                return response
            } catch (error) {
                throw Error(error)
            }
        },
        setAgrofagsSearchQuery({ state, commit }, payload) {
            // check if payload has valid properties
            commit('SET_AGROFAGS_QUERY', payload)
        },
        resetAgrofagsQuery({ commit, dispatch }) {
            commit('SET_AGROFAGS_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'agrofags',
                object: 'query'
            })
        },
        resetAgrofagsPagination({ commit, dispatch }) {
            commit('SET_AGROFAGS_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'agrofags',
                object: 'pagination'
            })
        }
    },
    getters: {
        agrofagsStatus: (state) => {
            return state.status
        },
        agrofags: (state) => {
            if (state.agrofags) {
                return state.agrofags
            }
        },
        agrofagTypes: (state) => state.types,
        agrofagsQuery: (state) => state.query,
        agrofagsQueryString: (state) => {
            const pagination = `page=${state.pagination.page}&limit=${state.pagination.limit}`
            const params = Object.entries(state.query)
                .filter(([key, value]) => value !== '')
                .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
                .join('&')
            return `${pagination}&${params}`
        }
    }
}
